import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { get } from '@front/common/src/api/requester';
import type { GiftCard } from '@front/common/src/types/commons';

const api = {
  get: (code: string) => get(`/customer/gifts/${code}`),
};

const GIFT_CARDS_QUERY_KEY = 'gift_cards';

type UseFetchGiftParams = {
  code: GiftCard['code'];
  options?: Pick<UseQueryOptions<GiftCard>, 'enabled'>;
};

export const useFetchGift = ({ code, options }: UseFetchGiftParams) => {
  const { data: giftCard, error: giftCardError } = useQuery<GiftCard, Error>({
    queryKey: [GIFT_CARDS_QUERY_KEY, code],
    queryFn: async () => {
      const response = await api.get(code);

      return response.data;
    },
    ...options,
  });
  return { giftCard, giftCardError };
};
